export const mapBoxKey = 'pk.eyJ1IjoibWFyY2VscGFsbWVyIiwiYSI6ImNrdXZsaXhvNjBhdW4yb212NHZteGdhdDMifQ.rSwab9KFKqLjuDG2UjS7bQ';